"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _GetStartedCardActions = require("../actions/GetStartedCardActions");

var _handleActions;

var initialState = new _immutable.Map({
  getStartedCardIsOpen: true,
  automationTipPopoverOpen: false
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _GetStartedCardActions.GetStartedCardActions.DISMISS_CARD, function (state) {
  return state.set('getStartedCardIsOpen', false);
}), (0, _defineProperty2.default)(_handleActions, _GetStartedCardActions.GetStartedCardActions.TOGGLE_AUTOMATION_POPOVER, function (state, action) {
  return state.set('automationTipPopoverOpen', action.payload.automationTipPopoverOpen);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;